import ArticleImage from '~/components/ArticleImage'
import ArticleImageText from '~/components/ArticleImageText'
import ArticlePush from '~/components/ArticlePush'
import ArticleTags from '~/components/ArticleTags'
import ArticleText from '~/components/ArticleText'
import ArticleTitle from '~/components/ArticleTitle'
import CurveComponent from '~/components/CurveComponent'
import HeroArticle from '~/components/HeroArticle'
import Quote from '~/components/Quote'
import Quotes from '~/components/Quotes'
import Separator from '~/components/Separator'
import { MapSliceTypeToComponent } from '~/components/SliceManager'

/**
 * Article map slice components imports
 */
const mapSliceToComponent: MapSliceTypeToComponent = {
  article_image_text: ArticleImageText,
  article_image: ArticleImage,
  article_push: ArticlePush,
  article_tags: ArticleTags,
  article_text: ArticleText,
  article_title: ArticleTitle,
  curve_component: CurveComponent,
  hero_article: HeroArticle,
  quote: Quote,
  quotes: Quotes,
  separator: Separator,
}

export default mapSliceToComponent
